import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { TransformFloat } from '../../../shared/decorators/transform-float.decorator';
import { TransformInt } from '../../../shared/decorators/transform-int.decorator';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { PricingItemDto } from '../../../shared/modules/pricing-items/dtos/pricing-item.dto';
import { ThirdPartyContactDto } from '../../contacts/dtos/third-party-contact.dto';
import { TagDto } from '../../tags/dtos/tag.dto';
import { VehicleDamageFaultEnum } from '../enums/vehicle-damage-fault.enum';
import { VehicleDamageRecordCategoryEnum } from '../enums/vehicle-damage-record-category.enum';
import { VehicleDamageSeverityEnum } from '../enums/vehicle-damage-severity.enum';
import { VehicleDamageTypeEnum } from '../enums/vehicle-damage-type.enum';

/**
 * Create vehicle damage DTO
 */
export class CreateVehicleDamageDto {
	color?: string | null;
	code!: string;
	notes?: string | null;
	recordCategory!: VehicleDamageRecordCategoryEnum;
	@TransformDate()
	reportedAt!: Date;
	type?: VehicleDamageTypeEnum | null;
	fault?: VehicleDamageFaultEnum | null;
	severity?: VehicleDamageSeverityEnum | null;
	policeReportFiled?: boolean | null;
	policeReportExternalReference?: string | null;
	@TransformFloat()
	estimatedCost?: number | null;
	@TransformInt()
	vehicleId?: number | null;
	@TransformInt()
	rentalAgreementId?: number | null;
	@TransformInt()
	scrapId?: number | null;
	thirdPartyContact?: ThirdPartyContactDto | null;
	@TransformInt()
	thirdPartyInsuranceId?: number | null;
	@TransformInt()
	insuranceClaimId?: number | null;
	pricingItems?: PricingItemDto[] | null;
	tags?: TagDto[] | null;
	files?: FileDto[] | null;
}
